<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <StatusFilters @onStatusChange="changeStatus" />
    </v-col>

    <v-col cols="12">
      <v-text-field
        background-color="kbWhite"
        solo
        flat
        hide-details
        :label="$t('general.search')"
        prepend-inner-icon="mdi-magnify"
        v-model="search"
      />
    </v-col>

    <v-col cols="12" class="align-self-stretch pt-0">
      <v-data-table
        fixed-header
        :footer-props="footerProps"
        :headers="headers"
        :height="tableHeight"
        :items="emails"
        :options.sync="options"
        :server-items-length="totalEmails"
      >
        <template v-slot:item.createdAt="{ item }">
          {{ $moment(item.createdAt).format('DD-MM-YYYY') }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip color="kbBlue"
                  dark
                  style="text-transform: uppercase">
            {{ item.status }}
          </v-chip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import oauthService from '@/services/oauthService.js'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import StatusFilters from './StatusFilters'
export default {
  components: { StatusFilters },
  computed: {
    headers () {
      return [
        { text: this.$t('general.to'), sortable: false, value: 'to' },
        { text: this.$t('general.date'), value: 'createdAt' },
        { text: this.$t('general.status'), value: 'status' }
      ]
    },
    footerProps () {
      return {
        'items-per-page-text': `Emails ${this.$t('general.perPage')}`,
        'items-per-page-options': [50, 100, 200]
      }
    },
    tableHeight () {
      return `calc(${this.dataTableHeight} - 90px)`
    }
  },
  data: () => ({
    emails: [],
    options: {},
    responseStatus: '',
    search: '',
    totalEmails: 0
  }),
  methods: {
    changeStatus ({ value }) {
      this.responseStatus = value
      this.options.page = 1
      this.getSentEmails()
    },
    async getSentEmails () {
      try {
        const data = {
          pagination: {
            page: this.options.page,
            itemsPerPage: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            descending: this.options.sortDesc[0]
          },
          responseStatus: this.responseStatus,
          search: this.search
        }

        const response = await oauthService.getSentEmails(data)
        this.emails = response.email
        this.totalEmails = response.count
      } catch (e) {
        notifications.error(e.message)
      }
    }
  },
  mixins: [ModuleTableHeight],
  watch: {
    options: {
      handler () {
        this.getSentEmails()
      },
      deep: true
    },
    search () {
      this.getSentEmails()
    }
  }
}
</script>
